<template>
  <div
    class="lp-datetimepicker-wrapper"
    :class="[preview && 'lp-datetimepicker-preview']"
  >
    <span v-if="labelTop" class="lp-input-label font-weight-medium">
      {{ labelTop }}
      <span v-if="!preview && required" class="text-blue">*</span>
    </span>
    <div
      class="lp-datetimepicker"
      :class="[!preview && 'ly-even-2 ly-end-end']"
      v-bind="$attrs"
    >
      <lp-datepicker
        v-model="date"
        :input-format="dateFormat"
        :message="message"
        :required="required"
        :disabled="disabled"
        :typeable="typeable"
        :clearable="clearable"
        :preview="preview"
        :compact="preview"
        v-bind="$attrs"
        data-ua-unique-id="ua-datetimepicker-datepicker"
        @update:model-value="onChange"
      />
      <lp-time-picker
        v-model="time"
        label-top=""
        :default="defaultValue"
        :format="timeFormat"
        :message="message"
        :interval="timeInterval"
        :disabled="disabled"
        :preview="preview"
        v-bind="$attrs"
        data-ua-unique-id="ua-datetimepicker-timepicker"
        @update:model-value="onChange"
      />
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'lp-datetimepicker',
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { format } from 'date-fns'

const emit = defineEmits(['update:model-value'])

interface Props {
  modelValue: Date | string | null
  labelTop?: string | null
  status?: string
  defaultValue?: Date | null
  message?: string | null
  disabled?: boolean
  typeable?: boolean
  clearable?: boolean
  preview?: boolean
  required?: boolean | null
  dateFormat?: string | null
  timeFormat?: string | null
  timeInterval?: string | number | null
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  labelTop: null,
  status: 'neutral',
  defaultValue: null,
  message: null,
  disabled: false,
  typeable: false,
  clearable: false,
  preview: false,
  required: false,
  dateFormat: 'MM/dd/yyyy',
  timeFormat: 'hh:mm a',
  timeInterval: 5,
})

const date = props.modelValue ? ref(props.modelValue) : ref(null)
const time = props.modelValue ? ref(props.modelValue) : ref(null)
const onChange = () => {
  emit(
    'update:model-value',
    date.value && time.value
      ? new Date(`
          ${date.value ? format(date.value, props.dateFormat) + ',' : ''} ${
            time.value
              ? date.value
                ? format(time.value, props.timeFormat)
                : format(time.value, props.dateFormat + ', ' + props.timeFormat)
              : ''
          }
        `)
      : null,
  )
}

watch(
  () => props.modelValue,
  (newValue) => {
    date.value = newValue
    time.value = newValue
  },
)
</script>
